import MobileGate from './MobileGate'

export default MobileGate
